import Seo from "@/lib/Seo";
import { useSite } from "@/context/SiteContext";
import Hero from "@/components/home/Hero";
import Concept from "@/components/home/Concept";
import Gameplay from "@/components/home/Gameplay";
import AppOffers from "@/components/home/AppOffers";
import Trust from "@/components/home/Trust";
import Social from "@/components/home/Social";

export default function Home() {
  const { settings, pricing } = useSite();
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "Product",
    name: "Douzième Homme — Le Jeu · Édition Nice",
    description: settings?.seo_description,
    brand: { "@type": "Brand", name: "Douzième Homme — Le Jeu" },
    offers: {
      "@type": "Offer",
      priceCurrency: "EUR",
      price: pricing?.price_1 ?? 34.9,
      availability: "https://schema.org/InStock",
      url: `${settings?.site_url || ""}/acheter`,
    },
  };
  return (
    <>
      <Seo path="/" jsonLd={jsonLd} />
      <Hero />
      <Concept />
      <Gameplay />
      <AppOffers />
      <Trust />
      <Social />
    </>
  );
}
